import shopify_product8376887557 from './shopify_product-8376887557';

export default {
  'shopify_product-8376887557': shopify_product8376887557
};



// WEBPACK FOOTER //
// ./src/store/data/generated/products/index.jsx